import { useEffect, useState } from "react";
import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { api } from "@/lib/api";

const CATEGORIES = [
  "Apistogramma", "Rams", "Other tropical cichlids",
  "Community breeding projects", "Fry development", "Grow-out tanks",
];

const StatusPill = ({ status }) => (
  <span className="text-[10px] uppercase tracking-wider bg-brand-cyan/15 text-brand-cyan px-2.5 py-1 rounded-full">
    {status}
  </span>
);

export const BreedingSection = () => {
  const [projects, setProjects] = useState([]);
  useEffect(() => {
    api.get("/breeding").then((r) => setProjects(r.data)).catch(() => {});
  }, []);

  return (
    <section className="py-24 lg:py-32 bg-brand-surface" data-testid="breeding-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl">
          <SectionLabel>The Breeding Room</SectionLabel>
          <h2 className="mt-4 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white leading-tight">
            BRED HONESTLY — SUCCESSES AND FAILURES
          </h2>
          <p className="mt-5 text-brand-textSec leading-relaxed">
            Breeding projects will be documented honestly. Nothing here is guaranteed — species and setups
            may change as the project develops. These are the kinds of projects on the table.
          </p>
        </Reveal>

        <div className="mt-8 flex flex-wrap gap-2" data-testid="breeding-categories">
          {CATEGORIES.map((c) => (
            <span key={c} className="text-xs text-brand-textSec border border-white/10 rounded-full px-3.5 py-1.5">
              {c}
            </span>
          ))}
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.08}>
              <div className="group card-surface overflow-hidden h-full" data-testid={`breeding-card-${p.id}`}>
                <div className="relative aspect-[4/3] overflow-hidden">
                  {p.image ? (
                    <img src={p.image} alt={p.species} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  ) : (
                    <div className="w-full h-full bg-brand-elevated grid place-items-center text-brand-textMuted text-xs">Photos coming soon</div>
                  )}
                  <div className="absolute top-3 left-3 flex gap-2">
                    <StatusPill status={p.status} />
                  </div>
                  {p.is_sample && (
                    <span className="absolute top-3 right-3 text-[10px] uppercase tracking-wider bg-brand-base/70 backdrop-blur text-brand-textSec px-2.5 py-1 rounded-full">
                      Sample
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="font-display font-semibold text-white text-lg">{p.species}</h3>
                  </div>
                  {p.category && <p className="text-brand-cyan text-xs mt-0.5">{p.category}</p>}
                  {p.summary && <p className="mt-3 text-brand-textSec text-sm leading-relaxed">{p.summary}</p>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
